

export const SidebarData = [
  {
    title: 'Home',
    path: '/',
    cName: 'nav-text'
  },
  {
    title: 'Services',
    path: '/services',
    cName: 'nav-text'
  },
  {
    title: 'Women Territory',
    path: '/womenterritory',
    cName: 'nav-text'
  },
  {
    title: 'Founders Pledge',
    path: '/founder',
    cName: 'nav-text'
  },
  {
    title: 'About us',
    path: '/aboutus',
    cName: 'nav-text'
  }
];